import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { CustomerPaymentMethod } from 'src/features/paymentMethods/utils/types';

const RESOURCE = '/customers/customer-payment-method/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    customer?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<CustomerPaymentMethod>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_CUSTOMER_PAYMENT_METHODS_RESOURCE, useQueryHook as useListCustomerPaymentMethods };
